import AlertIconError from 'src/assets/icons/alert-icon-error.svg';
import AlertIconSuccess from 'src/assets/icons/alert-icon-success.svg';
import AlertIconWarning from 'src/assets/icons/alert-icon-warning.svg';
import AlertIconInfo from 'src/assets/icons/alert-icon-info.svg';
import './Alert.scss';
import { Typography } from "src/latest/src/components";


const IconConfig = {
  error: AlertIconError,
  success: AlertIconSuccess,
  warning: AlertIconWarning,
  info: AlertIconInfo,
};

interface AlertProps {
  message: string;
  type: 'error' | 'success' | 'warning' | 'info';
  className: string;
}

export const Alert: React.FC<AlertProps> = ({ type, message, className }) => {
  return (
    <div className={`${className} alert-container alert-container-${type}`}>
      <img src={IconConfig[type]} alt="roles" />
      <Typography
        variant="size-16"
        color="color-2"
        weight="regular"
        className="ml-2"
      >
        {message}
      </Typography>
    </div>
  );
};
